import { render, staticRenderFns } from "./CompetitorsScreen.vue?vue&type=template&id=30e86054&scoped=true"
import script from "./CompetitorsScreen.vue?vue&type=script&lang=js"
export * from "./CompetitorsScreen.vue?vue&type=script&lang=js"
import style0 from "./CompetitorsScreen.vue?vue&type=style&index=0&id=30e86054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e86054",
  null
  
)

export default component.exports